import { Modal, Form, Input, Spin, Button } from 'antd';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import { postRequest } from "../../utils/APICall";
import { useState } from 'react';

const UpdatePassword = ({ confrimModal, setConfrimModal, onUpdatePassword }) => {

  const [form] = Form.useForm();
  const { users } = useSelector((state) => state.user || {})
  const [openNewPassInputs, setOpenNewPassInputs] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values) => {
    // console.log("Form Values:", values); //
    onUpdatePassword(values); // 
    setLoading(true)

    try {

      const response = await postRequest("login", values)
      // console.log("response->>>>>",response)
      if (response?.status) {
        // console.log("Add New Password wale messages render hon ge");
        setLoading(false)
        setOpenNewPassInputs(true)
        form.resetFields();
        toast.info("Add New Password", { autoClose: 2000 });
      }
      else {
        toast.error(response.message, { autoClose: 2000 });
      }

    }
    catch (error) {
      toast.error(error.message, { autoClose: 2000 });
      setLoading(false)
    }

  };

  const newPasswordHandler = async (values) => {
    const payload = {
      newPassword: values.newPassword,
      userid: users.USERID
    }
    try {
      const res = await postRequest('updatePassword', payload)
      // console.log(res)
      if (res.status) {
        toast.success("successfully Change Password", { autoClose: 2000 })
        form.resetFields();
        setConfrimModal(false)
        setOpenNewPassInputs(false)
      }
    } catch (error) {
      console.log(error)
      toast.error(error.message, { autoClose: 2000 });
    }
  }

  return (

    <Modal
      title={
        <div className="flex items-center gap-2 text-red-600 text-lg font-semibold">
          Update Password
        </div>
      }
      centered
      open={confrimModal}
      onOk={() => form.submit()} 
      onCancel={() => {
        setConfrimModal(false)
        setOpenNewPassInputs(false)
      }}
      footer={
        loading
          ? null 
          : [
            <Button key="cancel" onClick={() => setConfrimModal(false)}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading} 
              onClick={() => form.submit()} // trigger form submit
            >
              Submit
            </Button>,
          ]
      }
      okButtonProps={{ className: 'bg-red-500 hover:bg-red-600 text-white' }}
    >
      {

        loading ? <div className='flex w-full h-40 items-center justify-center i'><Spin size="large" /></div> :
          <>
            {
              !openNewPassInputs ?
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                >
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Enter a valid email" },
                    ]}
                  >
                    <Input placeholder="Enter your email" />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[{ required: true, message: "Please enter your password" }]}
                  >
                    <Input.Password placeholder="Enter your password" />
                  </Form.Item>
                </Form>
                :
                <Form form={form} layout="vertical" onFinish={newPasswordHandler}>
                  {/* New Password */}
                  <Form.Item
                    name="newPassword"
                    label="New Password"
                    rules={[
                      { required: true, message: "Please enter your new password" },
                      { min: 1, message: "Password must be at least 6 characters long" },
                    ]}
                    hasFeedback
                  >
                    <Input.Password placeholder="Enter new password" />
                  </Form.Item>

                  {/* Confirm Password */}
                  <Form.Item
                    name="confirmNewPassword"
                    label="Confirm Password"
                    dependencies={["newPassword"]}
                    hasFeedback
                    rules={[
                      { required: true, message: "Please confirm your password" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("newPassword") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords do not match!")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="Confirm new password" />
                  </Form.Item>
                </Form>
            }
          </>

      }

      <ToastContainer />
    </Modal>

  );
};

export default UpdatePassword;
